// extracted by mini-css-extract-plugin
export default {"title":"e66e4000a3","inner_title":"ddfc6f2959","charge_btn":"bd5a7af330"};